export const ROUTE_PERMISSIONS: Record<string, string[]> = {
  // PDF Analysis (Booklet Analysis) - View permission controls sidebar visibility
  '/pdf-analysis': ['uploaded_booklets_view'],
  '/pdf-analysis/portfolios': ['uploaded_booklets_view'], // NQG-RQ-29
  '/pdf-analysis/generate': ['question_generator_view'],
  '/pdf-analysis/question-bank': ['question_bank_view'],
  '/sharepoint-sync': ['sharepoint_sync_view'],

  // Slides - View permission controls sidebar visibility
  '/slides-maker': ['slides_maker_view'],
  '/slides-history': ['slides_history_view'],
  '/pptx-converter': ['pptx_converter_view'],
  '/pptx-history': ['pptx_history_view'],

  // Content Assembly
  '/content-assembly': ['content_assembly_view'],

  // Analytics
  '/analytics': ['analytics_dashboard_view'],

  // Compliance
  '/compliance': ['compliance_review_view'],
  '/regulations': ['regulations_management_view'],

  // AI Chatbot
  '/chatbot': ['ai_chatbot_view'],
  '/chatbot/feedback': ['chatbot_feedback_view'], // Feedback reports (Carlos/Lucas)

  // Editorial Workflow (NWFE-RQ-01) — permission comes from the reviewer
  // roles (linguist/professor) or admin via ROLE_PERMISSIONS
  '/editorial/review-tasks': ['review_task_view'],
  '/editorial/rejections': ['review_task_view'],
  '/editorial/ai-review': ['ai_review_monitor'],
  '/editorial/ai-prompts': ['prompt_manage'],

  // Settings (Administration)
  '/settings/users': ['user_management_view'],
  '/settings/permissions': ['permissions_management_view'], // Permission modules page
  '/settings/role-management': ['role_management_view'], // Role names management
  '/settings/system': ['system_configuration_view'],
  '/settings/api': ['system_configuration_view'],
  '/settings/rag': ['system_configuration_view'],
};

export function hasRoutePermission(
  path: string,
  userPermissions: string[]
): boolean {
  const requiredPerms = ROUTE_PERMISSIONS[path];
  if (!requiredPerms || requiredPerms.length === 0) return true;
  return requiredPerms.some(perm => userPermissions.includes(perm));
}
